import axios from "axios";
import { decrypt } from "../../utils/encryptDecrypt";

export const _retrieveToken = async () => {
  const value = await localStorage.getItem("admin-token");
  return value;
};

export const _retrieveForgotToken = async () => {
  const value = await localStorage.getItem("forgot_token");
  return value;
};

export const _removeData = async () => {
  try {
    await localStorage.removeItem("admin-token");
  } catch (error) {
    console.log(error);
  }
};

const http = axios.create({
  // baseURL: "http://localhost:5001/api/v1/backend/admin/",
  // baseURL: "https://exam.inroad.in/drapis/api/v1/backend/admin/",
  // baseURL: "https://exam.inroad.in/lab-apis/api/v1/backend/admin/",
  baseURL: "https://qcht4ops9l.execute-api.ap-south-1.amazonaws.com/la-he/admin/", // ** Production ** //

});

const authHttp = axios.create({
  // baseURL: "http://localhost:5001/api/v1/backend/admin/",
  // baseURL: "https://exam.inroad.in/lab-apis/api/v1/backend/admin/",
  baseURL: "https://qcht4ops9l.execute-api.ap-south-1.amazonaws.com/la-he/admin/", // ** Production ** //

});

authHttp.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      // await _removeData();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
authHttp.interceptors.request.use(
  async (config) => {
    const token = await _retrieveToken();
    const forgtoptoken = await _retrieveForgotToken();
    const t = token || forgtoptoken;
    if (t !== null && typeof t !== "undefined") {
      config.headers.Authorization = `Bearer ${decrypt(JSON.parse(t))}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export { authHttp };

export default http;
